{
  "version": 1,
  "asset_id": "a3a70d13-53e1-47a7-89f1-0f4f66c90586",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/a3a70d13-53e1-47a7-89f1-0f4f66c90586/sleeve-amateur-1-220.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/a3a70d13-53e1-47a7-89f1-0f4f66c90586/sleeve-amateur-1-220.webp",
  "original_filename": "sleeve-amateur-1-220.webp",
  "size": 3918,
  "content_type": "image/webp",
  "created_at": "2026-09-29T01:15:23Z"
}
